import request from '@/router/axios'

/**
 * OPC 点位分页 — POST /api/produce/opc-point/selectPage（JSON Body，与 OpcPointController#selectPage 一致）
 */
export function getList(params) {
  return request({
    url: '/api/produce/opc-point/selectPage',
    method: 'post',
    data: params,
    headers: { 'Content-Type': 'application/json' }
  })
}

export function getDetail(id) {
  return request({
    url: '/api/produce/opc-point/selectId',
    method: 'get',
    params: { id }
  })
}

export function add(data) {
  return request({
    url: '/api/produce/opc-point/insert',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/produce/opc-point/update',
    method: 'post',
    data
  })
}

/**
 * 集控模拟：仅更新 currentValue、collectTime（POST /produce/opc-point/updateCurrentValue）
 */
export function updateCurrentValueOnly(data) {
  return request({
    url: '/api/produce/opc-point/updateCurrentValue',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/json' }
  })
}

export function remove(id) {
  return request({
    url: '/api/produce/opc-point/deleteId',
    method: 'get',
    params: { id }
  })
}

/**
 * 批量采集点位（GET /produce/opc-collect/collectBatch?pointIds=1,2,3）
 */
export function collectBatch(pointIds) {
  return request({
    // 由 devServer proxy 分流：/api/produce/** -> localhost:9993
    url: '/api/produce/opc-collect/collectBatch',
    method: 'get',
    params: { pointIds }
  })
}

/**
 * 采集单个点位（GET /produce/opc-collect/collectByPointId?pointId=123）
 */
export function collectByPointId(pointId) {
  return request({
    url: '/api/produce/opc-collect/collectByPointId',
    method: 'get',
    params: { pointId }
  })
}

/**
 * 全量采集（GET /produce/opc-point/collectAll?batchSize=500）
 */
export function collectAll(batchSize) {
  return request({
    // 由 devServer proxy 分流：/api/produce/** -> localhost:9993
    url: '/api/produce/opc-collect/collectAll',
    method: 'get',
    params: { batchSize }
  })
}
